import FUmkm from "@/models/umkm/f-umkm";
import FtUmkmPermit from "@/models/umkm/ft-umkm-permit";

export const permit = {
  namespaced: true,
  state: {
    itemModified: new FUmkm(),

    itemFtUmkmPermit : new FtUmkmPermit(),
    listFtUmkmPermit: [],

    itemsFPermit: [],
  },
  actions: {
    updateItemModified({commit}, payload){
      commit('mutateItemModified', payload)
    },

    updateItemFtUmkmPermit({commit}, payload){
      commit('mutateItemFtUmkmPermit', payload)
    },
    updateListFtUmkmPermit({commit}, payload){
      commit('mutateListFtUmkmPermit', payload)
    },

    updateItemsFPermit({commit}, payload){
      commit('mutateItemsFPermit', payload)
    },

  },
  mutations: {
    mutateItemModified(state, payLoad){
      state.itemModified = payLoad
    },

    mutateItemFtUmkmPermit(state, payLoad){
      state.itemFtUmkmPermit = payLoad
    },
    mutateListFtUmkmPermit(state, payLoad){
      state.listFtUmkmPermit = payLoad
    },

    mutateItemsFPermit(state, items){
      state.itemsFPermit = items
    },

  },

};
